import { useQuery } from '@apollo/client'

import { GetCatAndSubCatCategoriesDocument } from '@/graphql/purchase-plus/generated/getCatAndSubCatCategories.generated'
import {
  CategoriesQuerySortPropertyEnum,
  SortDirectionEnum,
} from '@/graphql/purchase-plus/generated/purchasePlus_graphql'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'
import { extractEdgesWithType } from '@/modules/shared/utils/extractEdgesWithType'
import { createPaginationUtils } from '@/modules/shared/utils/paginationUtils'

interface UseGetCatAndSubCatCategoriesProps {
  skip?: boolean
}

export function useGetCatAndSubCatCategories(args?: UseGetCatAndSubCatCategoriesProps) {
  const { skip = false } = args || {}
  const paginationResultsPerPage = 10
  const { data, networkStatus, refetch, fetchMore } = useQuery(GetCatAndSubCatCategoriesDocument, {
    context: { uri: PURCHASE_PLUS_GRAPHQL_API },
    variables: {
      first: paginationResultsPerPage,
      sorts: [{ property: CategoriesQuerySortPropertyEnum.Name, direction: SortDirectionEnum.Asc }],
      filters: { hasParent: false },
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip,
  })

  const pageInfo = data?.categories?.pageInfo

  return {
    categories: extractEdgesWithType(data?.categories),
    networkStatus,
    loadingStates: checkNetworkStatus(networkStatus),
    refetch,
    ...createPaginationUtils({ pageInfo, fetchMore, refetch, paginationResultsPerPage }),
    pageInfo,
  }
}
